/**
 * Derive domain configuration from the current browser hostname.
 *
 * For "elbooks.elsapiens.test" → rootDomain = "elsapiens.test"
 * For "elbooks.appunveil.com"  → rootDomain = "appunveil.com"
 */

const hostname = window.location.hostname;
const parts = hostname.split('.');

// Root domain: strip the first subdomain segment (e.g. "elbooks")
// For localhost or single-segment hostnames, use as-is
/* v8 ignore next 7 -- ternaries depend on runtime hostname which is always 'localhost' in tests */
export const ROOT_DOMAIN = parts.length > 2 ? parts.slice(1).join('.') : hostname;

// Cookie domain needs leading dot for cross-subdomain sharing
export const COOKIE_DOMAIN = parts.length > 2 ? `.${ROOT_DOMAIN}` : hostname;

// Protocol from the current page
export const PROTOCOL = window.location.protocol === 'https:' ? 'https' : 'http';

// Auth subdomain — override via env var for deployments where it differs
export const AUTH_SUBDOMAIN: string = (import.meta.env.VITE_AUTH_SUBDOMAIN as string | undefined) ?? 'elauth';

// Full auth origin
export const AUTH_ORIGIN = `${PROTOCOL}://${AUTH_SUBDOMAIN}.${ROOT_DOMAIN}`;
